/**
 * Supabase Edge URL + env checks for public candidate interview pages (Vite).
 * Variables must be in `.env` / `.env.local` at the B2B app root; restart `npm run dev` after changes.
 */

export function getSupabaseProjectUrl(): string | null {
  const raw = import.meta.env.VITE_SUPABASE_URL;
  if (typeof raw !== 'string' || !raw.trim()) return null;
  return raw.replace(/\/+$/, '');
}

export function getInterviewPublicEdgeUrl(): string | null {
  const base = getSupabaseProjectUrl();
  if (!base) return null;
  return `${base}/functions/v1/ggj_b2b_ai_interview_public`;
}

export function hasSupabaseAnonKey(): boolean {
  const k = import.meta.env.VITE_SUPABASE_ANON_KEY;
  return typeof k === 'string' && k.trim().length > 0;
}

/** User-facing message if the app cannot call the interview API (missing env). */
export function interviewEdgeConfigErrorMessage(): string | null {
  if (!getSupabaseProjectUrl()) {
    return 'Interview API is not configured: add VITE_SUPABASE_URL to .env.local in the B2B app folder (your Supabase project URL, e.g. https://xxxx.supabase.co), then restart the dev server.';
  }
  if (!hasSupabaseAnonKey()) {
    return 'Interview API is not configured: add VITE_SUPABASE_ANON_KEY to .env.local (Supabase Dashboard → Project Settings → API → anon public), then restart the dev server.';
  }
  return null;
}
